<template>
  <v-container class="container-shadow">

    <div v-if="progress" class="overlay">
      <v-progress-circular
        :rotate="2"
        :size="100"
        :width="10"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>

    <div class="text-center py-5">
      <h2>นำเข้าข้อมูลพัสดุ</h2>
    </div>

    <ImportParcelDialog
      :dialog="showDialog"
      @close="showDialog = false"
      @data-upload="uploadedParcels"
    />

    <!-- Progress Dialog -->
    <v-dialog v-model="showProgressBar" max-width="500">
      <v-card>
        <v-card-title class="headline">กำลังบันทึกข้อมูลพัสดุ</v-card-title>
        <v-card-text>
          <v-progress-linear
            v-model="percentage"
            color="light-blue"
            height="20"
          >
            <strong>{{ this.markStatus }}/{{ this.getValueObjTotal }}</strong>
          </v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Progress Dialog -->

    <div class="text-center py-5 text-error" v-if="checkImportParcel">
      <h1>โครงการนี้เคย นำเข้าข้อมูลพัสดุไปแล้ว ไม่สามารถนำเข้าได้อีก</h1>
    </div>
    <div v-else>
      <v-card-actions class="pb-2">
        <v-spacer class="text-error">
          <span> หมายเหตุ </span><br />
          <span> - กรณี ประเภทพัสดุไม่ตรงกับระบบจะ Default : กล่องเล็ก </span
          ><br />
          <span> - กรณี ประเภทขนส่งไม่ตรงกับระบบจะ Default : อื่น ๆ </span>
        </v-spacer>
        
        <v-btn color="secondary" @click="downloadTemplate"> ดาวน์โหลดไฟล์ Template </v-btn>
        <v-btn color="primary" @click="exportDataExcel" style="width: 130px; background-color: #2a4e71 !important;" v-if="this.lengthParcel > 0">
          Export
        </v-btn>
        <v-btn color="primary" @click="openDialog" style="width: 130px; background-color: #255e97 !important;">
          เลือกไฟล์
        </v-btn>
        <v-btn color="primary" @click="saveParcels" style="width: 130px">
          {{ this.labelImportAll }}
        </v-btn>
      </v-card-actions>
      <v-data-table
        :headers="headers"
        :items="previewDatas"
        :loading="loading"
        item-key="id"
        height="500"
        fixed-header
        hide-default-footer
        :items-per-page="previewDatas.length"
      >
        <template v-slot:no-data>
          ไม่มีข้อมูล
          <!-- <v-alert type="info" border="none" elevation="2">
          ไม่มีข้อมูลแสดง
        </v-alert> -->
        </template>

        <template v-slot:item.importStatusCode="{ item }">
          <span
            v-if="
              item.importStatusCode === 'invalid' ||
              item.importStatusCode === 'error'
            "
            class="text-error"
            >{{ item.importStatusReason }} ❌</span
          >
          <span
            v-else-if="item.importStatusCode === 'success'"
            style="color: green"
          >
            บันทึกสำเร็จ ✔
          </span>
          <span
            v-else-if="item.importStatusCode === 'wait'"
            style="color: #2d4bd0"
          >
            รอบันทึก
          </span>
          <span v-else class="text-success">{{ item.importStatusCode }}</span>
        </template>

        <template v-slot:item.suCode="{ item }">
          <span class="text-green" style="color: green; font-weight: bold;">{{ item.suCode }}</span>
        </template>
      </v-data-table>
    </div>
  </v-container>
</template>

<script>
import axios from "@/axios";
import ImportParcelDialog from "../../components/Import/ImportParcelDialog.vue";
import useExportExcel from "../../hooks/exportExcel.js";
export default {
  components: {
    ImportParcelDialog,
  },
  setup() {
    const { generateFile } = useExportExcel();
    return {
      generateFile,
    }
  },
  data() {
    return {
      importAll: "นำเข้าทั้งหมด (:value)",
      showDialog: false,
      nt_runno: this.$route.params.nt_runno,
      username: this.$route.params.username,
      searchLotParcel: {
        nt_runno: this.$route.params.nt_runno,
        username: this.$route.params.username,
      },
      headers: [
        {
          text: "ลำดับ",
          value: "itemNo",
          align: "start",
          width: "10px",
          sortable: false,
        },
        {
          text: "บ้านเลขที่",
          value: "address",
          align: "start",
          width: "30px",
          sortable: false,
        },
        // {
        //   text: "เลขที่ยูนิต",
        //   value: "unit",
        //   align: "start",
        //   width: "40px",
        //   sortable: false,
        // },
        {
          text: "เลขทะเบียน",
          value: "barcode",
          align: "start",
          width: "50px",
          sortable: false,
        },
        {
          text: "ชื่อ-นามสกุล",
          value: "name",
          align: "start",
          width: "120px",
          sortable: false,
        },
        {
          text: "เบอร์มือถือ",
          value: "phone",
          align: "start",
          width: "40px",
          sortable: false,
        },
        {
          text: "ประเภทพัสดุ",
          value: "box",
          align: "start",
          width: "90px",
          sortable: false,
        },
        {
          text: "ประเภทขนส่ง",
          value: "logistic",
          align: "start",
          width: "95px",
          sortable: false,
        },
        // {
        //   text: "วันที่บันทึกรับพัสดุ",
        //   value: "createDate",
        //   align: "start",
        //   width: "90px",
        //   sortable: false,
        // },
        {
          text: "สถานะ",
          value: "importStatusCode",
          align: "start",
          width: "90px",
          sortable: false,
        },
        {
          text: "เลขที่อ้างอิง",
          value: "suCode",
          align: "start",
          width: "30px",
          sortable: false,
        },
      ],

      loading: false,
      previewDatas: [],
      valueObj: [],
      showProgressBar: false,
      markStatus: 1,
      checkImportParcel: false,
      waitCount: 0,      
      progress: true,
    };
  },
  async mounted() {    
    await this.getImportParcels();
    if (!this.checkImportParcel) {
      await this.getLogistics();
      await this.getBoxTypes();
      await this.getUnits();
      await this.getLotParcel();
    }

    this.progress = false;
    // console.log("000lotParcel=", this.lotParcel);
  },
  methods: {
    openDialog() {
      this.showDialog = true;
    },
    async getImportParcels() {
      try {
        await axios.get("/getImportParcels/" + this.nt_runno).then((res) => {
          // console.log("getImportParcels=", res.data.data);
          if (res.data.data.length > 0) {
            this.checkImportParcel = true;
          }
        });
      } catch (err) {
        console.log(err.message);
      }
    },
    async getLogistics() {
      await this.$store.dispatch("importParcel/getLogistics");
      // try {
      //   await axios.get("/GetLogistic").then((res) => {
      //     console.log("getLogistic=", res.data.data);
      //     this.logistics = res.data.data
      //   });
      // } catch (err) {
      //   console.log(err.message);
      // }
    },
    async getBoxTypes() {
      await this.$store.dispatch("importParcel/getBoxTypes");
      // try {
      //   await axios.get("/GetParcelType").then((res) => {
      //     console.log("getParcelType=", res.data.data);
      //     this.boxTypes = res.data.data
      //   });
      // } catch (err) {
      //   console.log(err.message);
      // }
    },
    async getUnits() {
      await this.$store.dispatch("importParcel/getUnits", this.nt_runno);
      // try {
      //   await axios.get("/getUnits/" + this.nt_runno).then((res) => {
      //     console.log("getUnit=", res.data.data);
      //     this.customers = res.data.data;
      //     // console.log('ParcelList', this.items)
      //   });
      // } catch (err) {
      //   console.log(err.message);
      // }
    },
    async getLotParcel() {
      await this.$store.dispatch(
        "importParcel/getLotParcel",
        this.searchLotParcel
      );
      // try {
      //   await axios.post("/GetLotParcel", this.searchLotParcel).then((res) => {
      //     console.log("getLotParcel=", res.data.data.LT_RUNNO);
      //     this.lt_runno = res.data.data.LT_RUNNO;
      //     // this.items = res.data.data;
      //     // console.log('ParcelList', this.items)
      //   });
      // } catch (err) {
      //   console.log(err.message);
      // }
    },
    uploadedParcels() {
      // console.log("uploadedParcels=", this.importParcels);
      this.valueObj = [];
      this.markStatus = 0;
      this.previewDatas = [...this.importParcels];
      if (!this.lotParcel) {
        this.getLotParcel();
      }
      this.filterDataByStatus("wait");
    },
    async saveParcels() {
      // console.log("saveParcels=", this.dataWaitStatus);
      // console.log("this.dataWaitStatus.length", [...this.dataWaitStatus].length);
      let parcels = [...this.importParcels].filter(
        (data) => data.importStatusCode === "wait"
      );
      if (!parcels || parcels.length == 0) {
        alert("ไม่สามารถบันทึกได้ เนื่องจากไม่มีรายการรอบันทึก");
        return true;
      }

      this.valueObj = [];
      this.valueObj = this.dataWaitStatus;
      this.showProgressBar = true;
      for (const data of this.dataWaitStatus) {
        await this.delay(1000); //หน่วงเวลา
        await this.addParcel(data);

        this.getMarkStatus();
        this.previewDatas = [...this.importParcels];
      }

      this.waitCount = 0;
      this.showProgressBar = false;
    },
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async addParcel(data) {
      try {
        let payload = {
          username: this.username,
          nt_runno: this.nt_runno,
          lt_runno: this.lotParcel,
          su_barcode: data.barcode,
          su_fullname: data.name,
          st_runno: data.boxId,
          pd_addr: data.address,
          su_phone: data.phone ? data.phone : "-",
          su_building: data.pd_building,
          pl_runno: data.logisticId,
          newCus: data.newCus,
          su_remark: "import",
        };

        // console.log("addParcel", payload);

        await axios.post("/SlotSaveParcelImport", payload).then((res) => {
          // console.log('submitParcel', res.data.data)
          if (res.data.data) {
            data.importStatusCode = "success";
            data.markStatus = "1";
            data.suRunno = res.data.data[0].ST_RUNNO;
            data.suCode = res.data.data[0].SU_CODE;
          } else {
            data.importStatusCode = "error";
            data.markStatus = "1";
          }
        });

        // data.importStatusCode = "success";
        // data.markStatus = "1";
        // data.suCode = "123456789";

        return true;
      } catch (error) {
        data.importStatusCode = "error";
        data.importStatusReason = error.message;
        data.markStatus = "1";
        return false;
      }
    },
    filterDataByStatus(status) {      
      if (this.lengthParcel > 0) {
        let data = [...this.importParcels].filter(
          (data) => data.importStatusCode === status
        );        
        this.waitCount = data.length;
        return [...data];
      }
      return [];
    },
    getMarkStatus() {
      if (this.valueObj) {
        let data = this.valueObj.filter((e) => e.markStatus !== "");
        if (data) {
          this.markStatus = data.length;
        }
      } else {
        this.markStatus = 1;
      }
    },
    exportDataExcel(){
      if(!this.lengthParcel){
        alert("ไม่มีรายการ นำเข้าข้อมูลพัสดุ");
        return true;
      }

      const columnName = [
          {
            field: "address",
            name: "บ้านเลขที่"
          },
          {
            field: "barcode",
            name: "เลขทะเบียน",
          },
          {
            field: "name",
            name: "ชื่อ-นามสกุล",
          },
          {
            field: "phone",
            name: "เบอร์มือถือ",
          },
          {
            field: "box",
            name: "ประเภทพัสดุ",
          },
          {
            field: "logistic",
            name: "ประเภทขนส่ง",
          },
          {
            field: "importStatusCode",
            name: "สถานะ",
          },
          {
            field: "importStatusReason",
            name: "รายละเอียด",
          },
          {
            field: "suCode",
            name: "เลขที่อ้างอิง",
          },
        ]
        this.generateFile(this.importParcels, columnName, "parcel_import", "นำเข้าข้อมูลพัสดุ", 2);
    },
    async downloadTemplate() {
      // console.log("downloadTemplate1:");
      this.progress = true;
      const url = "https://mediacenter.lpn.co.th/files/asset/Parcel/Template/avYpGaqEsrbVYH0Bjb07RfboE0xOn6ayX6cvjCt9.xlsx";
      const fileName = "Parcel_Template.xlsx"; // ชื่อใหม่ที่ต้องการ

      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const blob = await response.blob();

        // ใช้ FileSaver.js เพื่อบันทึกไฟล์ด้วยชื่อใหม่
        this.progress = false;
        saveAs(blob, fileName);
      } catch (error) {
        console.error("Download failed:", error);
        this.progress = false;
      }
    }, 
  },
  computed: {
    lotParcel() {
      return this.$store.getters["importParcel/lotParcel"];
    },
    importParcels() {
      return this.$store.getters["importParcel/importParcels"];
    },
    lengthParcel() {
      return [...this.importParcels].length;
    },
    dataWaitStatus() {
      return this.filterDataByStatus("wait");
    },
    labelImportAll() {
      let countData = 0;
      if (this.lengthParcel > 0) {
        // countData = this.dataWaitStatus.length;
        countData = this.waitCount;
      }
      return this.importAll.replace(":value", countData);
    },

    percentage() {
      if (this.valueObj) {
        // console.log("00this.getMarkStatus=",this.getMarkStatus);
        // console.log("00this.getValueObjTotal=",this.getValueObjTotal);
        if (this.getMarkStatus == 0) {
          return 1;
        }
        return Math.floor((this.markStatus / this.getValueObjTotal) * 100);
      }
      return 0;
    },
    getValueObjTotal() {
      if (this.valueObj) {
        return this.valueObj.length;
      }
      return 0;
    },
  },
};
</script>

<style>
.container-shadow {
  background-color: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 20px;
  border-radius: 8px;
}

.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  background-color: #c4c1c1; /* สีพื้นหลังของหัวตาราง */
  z-index: 10;
  text-align: center; /* จัดกลางในแนวนอน */
  vertical-align: middle; /* จัดกลางในแนวตั้ง */
  padding: 5px; /* ระยะห่างภายในเพื่อให้ตัวอักษรอยู่กลาง */
  color: rgb(0, 0, 0) !important;
  font-size: 14px;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 14px;
  color: rgb(0, 0, 0) !important;
  padding: 5px;
}
.text-error {
  color: red;
  font-size: 12px;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.8); /* เพิ่มพื้นหลังโปร่งแสง */
  z-index: 99;
}
</style>
